import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
import clsx from "clsx";
import { useCookies } from 'react-cookie';
import cookieName from '../../helpers/cookiesDeclaration';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';


const useGeneralStyles = GeneralStyles;


function TermsAndConditionsCategories(props) {
    const classesG = useGeneralStyles();
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie] = useCookies([cookieName]);

    const [termsCategories, setTermsCategories] = useState(null);
    const [termsContentNull, setTermsContentNull] = useState(null);
    const [termsSub, setTermsSub] = useState(null);
    const [termsContent, setTermsContent] = useState(null);

    const { url } = useParams();

    useEffect(() => {
        setLoading(true);
        if (url !== '' && url !== undefined && url !== null) {
            axios
                .get(
                    `${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-category/${url}`)
                .then((response) => {
                    setTermsCategories(response.data);

                    axios
                        .get(
                            `${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-content/category/${response.data.id}`)
                        .then((response) => {
                            setTermsContentNull(response.data);
                            setLoading(false);
                        })
                        .catch((error) => {
                            setLoading(true);
                        });

                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(true);
                });
        } else {
            setLoading(false);
            const { history, location } = props;
            const { from } = location.state || {
                from: {
                    pathname: '/terms&Conditions',
                },
            };
            history.push(from);
        }
    }, [url, props]);


    useEffect(() => {
        setLoading(true);
        if (termsCategories != null || termsCategories != undefined) {


            axios
                .get(
                    `${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-subcategories?_sort=id:ASC`)
                .then((response) => {
                    setTermsSub(response.data);
                    setLoading(false);
                    (async () => {
                        var array = [];

                        for (let index = 0; index < response.data.length; index++) {
                            const result = await axios.get(`${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-content/subcategory/${termsCategories.id}/${response.data[index].id}`);
                            const json = {
                                subcategory: response.data[index].Title,
                                content: result.data
                            };
                            array.push(json);
                        }
                        setTermsContent(array);
                    })()
                })
                .catch((error) => {
                    setLoading(true);
                });
        }
    }, [termsCategories, termsContentNull]);

    const handleRedirectTerms = () => {
        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/terms&Conditions`,
            },
        };
        history.push(from);
    };

    const handleRedirectContent = item => {
        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/terms&Conditions_content/${item}`,
            },
        };
        history.push(from);
    };


    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {termsCategories === null ? '' : (
                        <MetaTags>
                            <title>{termsCategories.Page_title}</title>
                            <meta name="description" content={termsCategories.Page_description} />
                        </MetaTags>
                    )}
                    {termsCategories === null || termsCategories === undefined ? '' : (
                        <div className={classesG.container}>
                            <section className={classesG.section}>
                                <div className={classesG.termsAndConditionsPage}>
                                    <div className={classesG.termsAndConditionsBox}>
                                        <div className={classesG.termsAndConditionsSectionTitle}>
                                            <h2>{termsCategories.Title}</h2>
                                            <a style={{ marginTop: '5px' }} onClick={() => handleRedirectTerms()} >
                                                Back to Terms & Conditions
                                            </a>
                                            <br />
                                        </div>


                                        <div className={classesG.termsAndConditionsCategories}>
                                            {termsContent === null || termsContent == [] ? '' : termsContent.map((items, i) => (
                                                (items.content == null || items.content.length == 0 ? '' :
                                                    <ul key={i} className={classesG.termsAndConditionsCategories_ul}>
                                                        <li>
                                                            {items.subcategory}

                                                            <ul>
                                                                {items.content === null || items.content == [] ? '' : items.content.map((cont, j) => (
                                                                    <li key={j} onClick={() => handleRedirectContent(cont.Url)}>
                                                                        {cont.Title}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                )
                                            ))}
                                            {termsContentNull === null || termsContentNull == [] ? '' : termsContentNull.map((items, i) => (
                                                <ul key={i} className={classesG.termsAndConditionsCategories_ul_null}>
                                                    <li onClick={() => handleRedirectContent(items.Url)}>
                                                        {items.Title}
                                                    </li>
                                                </ul>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                            </section>

                            <Box mt={45}></Box>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (TermsAndConditionsCategories);